import styled from 'vue3-styled-components';
import tokens from '@/styles/tokens'
import { props } from './letter-filter.shared';

const { colors } = tokens;
const textSize = '14px';
const textWidth = '24px';
const textHeight = '32px';

export const StLetterFilter = styled('ul', props)`
  display: flex;
  justify-items: center;
  gap: 1rem;
  align-items: center;
  padding: 0 6px;

  .list__letter {
    text-align: center;
    text-transform: uppercase;
    cursor: pointer;
    font-size: ${() => textSize};
    min-width: ${() => textWidth};
    height: ${() => textHeight};
    line-height: ${() => textHeight};

    &.active {
      color: ${() => colors.primary.DEFAULT};
    }

    &:hover {
      color: ${() => colors.primary.DEFAULT};
    }
  }
`
